import { useTranslation } from 'next-i18next'
import Reveal from '../../home-new/Reveal'
import styles from './OriginStory.module.scss'

// "จุดเริ่มต้นของ SHIPPOP" — globe/open-box illustration on the left, the
// origin story copy on the right (stacks image-above-text on mobile).
// Styling migrated from makeStyles to a static CSS Module.
const OriginStory = () => {
  const { t } = useTranslation('about-us')

  return (
    <section className={styles.root}>
      <div className={styles.container}>
        <div className={styles.gridContainer}>
          <div className={styles.gridItemMd5}>
            <Reveal direction="left">
              <div className={styles.artWrap}>
                <picture style={{ display: 'contents' }}>
                  <source
                    srcSet="/static/img/about-us-new/origin-story.webp"
                    type="image/webp"
                  />
                  <img
                    src="/static/img/about-us-new/origin-story.png"
                    alt={t('about.new.origin.art-alt')}
                    className={styles.art}
                    width={1320}
                    height={800}
                    loading="lazy"
                    decoding="async"
                  />
                </picture>
              </div>
            </Reveal>
          </div>
          <div className={styles.gridItemMd7}>
            <div className={styles.copy}>
              <Reveal direction="right">
                <h2 className={styles.heading}>
                  {t('about.new.origin.heading-prefix')} <span>SHIPPOP</span>
                </h2>
              </Reveal>
              <Reveal direction="right" delay={0.1}>
                <p className={styles.desc}>{t('about.new.origin.desc-1')}</p>
              </Reveal>
              <Reveal direction="right" delay={0.18}>
                <p className={styles.desc}>{t('about.new.origin.desc-2')}</p>
              </Reveal>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default OriginStory
